import React, { useEffect, useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { config } from "../utils/config";
import { useNavigate, useSearchParams } from "react-router-dom";
import { doRequest, isValidEmail, submitUserPlans } from "../utils/helper";
// import secureLocalStorage from "react-secure-storage";
import verifytoken from "../env/verifytoken";
import KEYS from "../env/env";

export default function PayAsUsePayment() {
  const initialUserPlanDetails = localStorage.getItem(config.USER_PLAN_DETAILS);
  const detail = localStorage.getItem(config.USER_LOGIN_DETAILS)
    ? JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS))
    : {};
  let obj = {
    ...detail,
    first_name: detail["first_name"] || "",
    last_name: detail["last_name"] || "",
    state: detail["state"] || "",
    country: detail["country"] || "",
    city: detail["city"] || "",
    postal_code: detail["postal_code"] || "",
    phone_no: detail["phone"] || "",
    email: detail["email"] || "",
    address: detail["address"] || "",
  };
  const [params] = useSearchParams();
  const initialSelectedPlan = params.get("plan");
  const [userDetails, setUserDetails] = useState({ ...obj });
  const [billingAddress, setBillingAddress] = useState({});
  const [billingSameAsUserDetails, setBillingSameAsUserDetails] =
    useState(false);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(
    initialSelectedPlan ? +initialSelectedPlan : ""
  );
  const [selectedPlan, setSelectedPlan] = useState({});
  const [gstCharges, setGstCharges] = useState("");
  const [discountApplied, setDiscountApplied] = useState(0);
  const [modal2, setModal2] = useState(false);
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastnameError] = useState(false);
  const [AddressError, setAddressError] = useState(false);
  const [phoneNoError, setPhoneNoError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [countryError, setCountryError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [postalCodeError, setPostalCodeError] = useState(false);
  const [billCityError, setBillCityError] = useState(false);
  const [billCountryError, setBillCountryError] = useState(false);
  const [billStateError, setBillStateError] = useState(false);
  const [billPostalError, setBillPostalError] = useState(false);

  const navigate = useNavigate();

  const userLoginDetails = localStorage.getItem(config.USER_LOGIN_DETAILS);
  if (!userLoginDetails) {
    alert("please login first");
    navigate("/Login");
  }

  const getPlansList = async () => {
    try {
      let res = await doRequest({}, "GET", `plan/list`);
      if (+res?.resultFlag === 1) {
        setSubscriptionList(res?.response?.plans);
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    getPlansList();
  }, []);

  const isPayNowFormValid = (details) => {
    let err = 0;
    if (!details["first_name"] || details["first_na me"] === "") {
      err += 1;
      setFirstNameError(true);
    } else {
      setFirstNameError(false);
    }
    if (!details["last_name"] || details["last_name"] === "") {
      err += 1;
      setLastnameError(true);
    } else {
      setLastnameError(false);
    }
    if (!details["address"] || details["address"] === "") {
      err += 1;
      setAddressError(true);
    } else {
      setAddressError(false);
    }
    if (!details["phone_no"] || details["phone_no"] === "") {
      err += 1;
      setPhoneNoError(true);
    } else {
      setPhoneNoError(false);
    }
    if (!details["email"] || details["email"] === "") {
      err += 1;
      setEmailError(true);
    } else {
      setEmailError(false);
    }
    if (!details["city"] || details["city"] === "") {
      err += 1;
      setCityError(true);
    } else {
      setCityError(false);
    }
    if (!details["country"] || details["country"] === "") {
      err += 1;
      setCountryError(true);
    } else {
      setCountryError(false);
    }

    if (!details["state"] || details["state"] === "") {
      err += 1;
      setStateError(true);
    } else {
      setStateError(false);
    }
    if (!details["postal_code"] || details["postal_code"] === "") {
      err += 1;
      setPostalCodeError(true);
    } else {
      setPostalCodeError(false);
    }

    if (!billingSameAsUserDetails) {
      if (!billingAddress["city"] || billingAddress["city"] === "") {
        err += 1;
        setBillCityError(true);
      } else {
        setBillCityError(false);
      }
      if (!billingAddress["country"] || billingAddress["country"] === "") {
        err += 1;
        setBillCountryError(true);
      } else {
        setBillCountryError(false);
      }
      if (!billingAddress["state"] || billingAddress["state"] === "") {
        err += 1;
        setBillStateError(true);
      } else {
        setBillStateError(false);
      }
      if (
        !billingAddress["postal_code"] ||
        billingAddress["postal_code"] === ""
      ) {
        err += 1;
        setBillPostalError(true);
      } else {
        setBillPostalError(false);
      }
    }

    if (err > 0) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (!selectedPlanId) return;
    let a = subscriptionList?.filter((i) => i.id == selectedPlanId);
    if (a && a.length > 0) {
      setSelectedPlan(a[0]);
      setGstCharges(a[0].price * (a[0]?.tax / 100));
    }
  }, [selectedPlanId, subscriptionList]);
  const onChangeHandler = (key, val) => {
    let details = { ...userDetails };
    details[key] = val;
    setUserDetails(details);
  };
  const billingAddressChangehandler = (key, val) => {
    let details = { ...billingAddress };
    details[key] = val;
    setBillingAddress(details);
  };

  const sameAddressClickHandler = (e) =>
    setBillingSameAsUserDetails(!billingSameAsUserDetails);
  const toggle2 = () => setModal2(!modal2);

  const onSuccessPaymentHandler = async (data) => {
    if (!data) {
      return;
    }

    let response = await doRequest(data, "POST", "order/validate");
    if (+response?.resultFlag === 1) {
      let obj = {
        imageCanDownload: localStorage.getItem("variationcounts"),
        downloadedCount: 0,
      };
      localStorage.setItem("userdownloadimage", JSON.stringify(obj));
      alert(
        `Congratulations!, you can download ${localStorage.getItem(
          "variationcounts"
        )} images now`
      );

      navigate("/payasuse/paid/export-new");
    }
  };

  const completePayment = async (orderDetails) => {
    if (!orderDetails) {
      return;
    }
    const options = {
      key:KEYS.razorPayID, // Enter the Key ID generated from the Dashboard
      amount: orderDetails?.amount.toString(),
      currency: "INR",
      name: "Variant",
      description: selectedPlan?.DESCR,
      image: `${config.s3BaseUrl}Logo/logo.jpg`,
      order_id: orderDetails?.order_id,
      handler: async function (response) {
       
        const data = {
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          order_id: orderDetails?.order_id,
          contact_details: userDetails,
          billing_details: billingSameAsUserDetails
            ? userDetails
            : billingAddress,
        };
        await onSuccessPaymentHandler(data);
      },
      prefill: {
        name: `${userDetails["first_name"]} ${userDetails["last_name"]}`,
        email: userDetails["email"],
        contact: userDetails["phone_no"],
      },
      notes: {
        address: userDetails["address"],
      },
      theme: {
        color: "#61dafb",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
    paymentObject.on("payment.failed", function (response) {
    });
  };

  const submitHandler = async () => {
    const userLoginDetails = localStorage.getItem(config.USER_LOGIN_DETAILS);
    if (!userLoginDetails) {
      alert("please login first");
      navigate("/Login");
    }
    let formIsValid = isPayNowFormValid(userDetails);
    if (!formIsValid) return;

    let reqData = {
      user_id: JSON.parse(userLoginDetails)?.id,
      plan_id: "2",
      variant: localStorage.getItem("variationcounts"),
    };
    // return;
    try {
      let response = await doRequest(reqData, "POST", "order/create");
      if (+response?.resultFlag === 1) {
        let orderDetails = response?.response?.orderCreate;
        completePayment(orderDetails);
      } else {
        alert(response?.message ? response?.message : "Something went wrong");
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    // var token = secureLocalStorage.getItem("Login");
    var token = localStorage.getItem("Login");

    if (!token || token == null) {
      alert("please login first");
      navigate("/");
    } else {
      var tokenExpired = verifytoken();
      if (tokenExpired) {
        navigate("/");
      }
    }
    let userplanDetails = localStorage.getItem(config.USER_PLAN_DETAILS)
      ? JSON.parse(localStorage.getItem(config.USER_PLAN_DETAILS))
      : null;
    if (!userplanDetails) {
      alert("please choose a plan first");
    }
    let count = localStorage.getItem("variationcounts");
    if (count < 1) {
      alert("please create variations first");
      navigate("/Design");
    }
  }, []);
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-xl-7 col-lg-7 col-sm-12">
            <div className="payment_div">
              <h3>Contact address</h3>
              <form>
                <div className="row">
                  <div className="col-xl-6 col-sm-6 ">
                    <div className="form_detail">
                      <input
                        type="text"
                        className="form-control card_form_height"
                        placeholder="First name"
                        value={userDetails["first_name"]}
                        onChange={(e) => {
                          e.target.value && setFirstNameError(false);
                          onChangeHandler("first_name", e.target.value);
                        }}
                      />
                      {firstNameError && (
                        <p className="text-danger">
                          Please enter your first name
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-xl-6 col-sm-6">
                    <div className="form_detail">
                      <input
                        type="text"
                        className="form-control card_form_height"
                        placeholder="Last name"
                        value={userDetails["last_name"]}
                        onChange={(e) => {
                          e.target.value && setLastnameError(false);
                          onChangeHandler("last_name", e.target.value);
                        }}
                      />
                      {lastNameError && (
                        <p className="text-danger">
                          Please enter your last name
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-12">
                    <div className="form_detail">
                      <input
                        type="text"
                        className="form-control card_form_height"
                        placeholder="Address"
                        value={userDetails["address"]}
                        onChange={(e) => {
                          e.target.value && setAddressError(false);
                          onChangeHandler("address", e.target.value);
                        }}
                      />
                      {AddressError && (
                        <p className="text-danger">Please enter your address</p>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-sm-6">
                    <div className="form_detail">
                      <input
                        type="number"
                        className="form-control card_form_height"
                        placeholder="Contact No."
                        value={userDetails["phone_no"]}
                        onChange={(e) => {
                          e.target.value && setPhoneNoError(false);
                          onChangeHandler("phone_no", e.target.value);
                        }}
                      />
                      {phoneNoError && (
                        <p className="text-danger">
                          Please enter your phone no
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-sm-6">
                    <div className="form_detail">
                      <input
                        type="text"
                        disabled
                        className="form-control card_form_height"
                        placeholder="Email Id"
                        value={userDetails["email"]}
                        // onChange={(e) =>
                        //   onChangeHandler("email", e.target.value)
                        // }
                      />
                      {emailError && (
                        <p className="text-danger">Please enter your email</p>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-sm-6">
                    <div className="form_detail">
                      <input
                        type="text"
                        className="form-control card_form_height"
                        placeholder="City"
                        value={userDetails["city"]}
                        onChange={(e) => {
                          e.target.value && setCityError(false);
                          onChangeHandler("city", e.target.value);
                        }}
                      />
                      {cityError && (
                        <p className="text-danger">Please enter your city</p>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-sm-6">
                    <div className="form_detail">
                      <input
                        type="text"
                        className="form-control card_form_height"
                        placeholder="Country"
                        value={userDetails["country"]}
                        onChange={(e) => {
                          e.target.value && setCountryError(false);
                          onChangeHandler("country", e.target.value);
                        }}
                      />
                      {countryError && (
                        <p className="text-danger">Please enter your country</p>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-sm-6">
                    <div className="form_detail">
                      <input
                        type="text"
                        className="form-control card_form_height"
                        placeholder="State"
                        value={userDetails["state"]}
                        onChange={(e) => {
                          e.target.value && setStateError(false);
                          onChangeHandler("state", e.target.value);
                        }}
                      />
                      {stateError && (
                        <p className="text-danger">Please enter your state</p>
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-sm-6">
                    <div className="form_detail">
                      <input
                        type="number"
                        className="form-control card_form_height"
                        placeholder="Postal Code"
                        value={userDetails["postal_code"]}
                        onChange={(e) => {
                          e.target.value && setPostalCodeError(false);
                          onChangeHandler("postal_code", e.target.value);
                        }}
                      />
                      {postalCodeError && (
                        <p className="text-danger">Please enter postal code</p>
                      )}
                    </div>
                  </div>

                  {/* <div className="col-xl-6 col-sm-6">
                      <button className="fromdetai_save">Save</button>
                    </div> */}
                </div>
              </form>
              <h3>Billing Address</h3>

              <div className="form-check">
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    className="form-check-input custom_checkbox"
                    value=""
                    checked={billingSameAsUserDetails}
                    onChange={(e) => sameAddressClickHandler(e)}
                  />
                  <span className="label_check">Same as contact address</span>
                </label>
              </div>

              {!billingSameAsUserDetails && (
                <>
                  <div className="row">
                    <div className="col-xl-6 col-sm-6">
                      <div className="form_detail">
                        <input
                          type="text"
                          className="form-control card_form_height"
                          placeholder="City"
                          value={billingAddress["city"]}
                          onChange={(e) => {
                            e.target.value && setBillCityError(false);
                            billingAddressChangehandler("city", e.target.value);
                          }}
                        />
                        {billCityError && (
                          <p className="text-danger">
                            Please enter billing city
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="form_detail">
                        <input
                          type="text"
                          className="form-control card_form_height"
                          placeholder="Country"
                          value={billingAddress["country"]}
                          onChange={(e) => {
                            e.target.value && setBillCountryError(false);
                            billingAddressChangehandler(
                              "country",
                              e.target.value
                            );
                          }}
                        />
                        {billCountryError && (
                          <p className="text-danger">
                            Please enter billing country
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="form_detail">
                        <input
                          type="text"
                          className="form-control card_form_height"
                          placeholder="State"
                          value={billingAddress["state"]}
                          onChange={(e) => {
                            e.target.value && setBillStateError(false);
                            billingAddressChangehandler(
                              "state",
                              e.target.value
                            );
                          }}
                        />
                        {billStateError && (
                          <p className="text-danger">
                            Please enter billing state
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6 col-sm-6">
                      <div className="form_detail">
                        <input
                          typef="number"
                          className="form-control card_form_height"
                          placeholder="Postal Code"
                          value={billingAddress["postal_code"]}
                          onChange={(e) => {
                            e.target.value && setBillPostalError(false);
                            billingAddressChangehandler(
                              "postal_code",
                              e.target.value
                            );
                          }}
                        />
                        {billPostalError && (
                          <p className="text-danger">
                            Please enter billing postal code
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="row">
                <div className="col-sm-6">
                  <h3>Tax settings</h3>
                  <div className="tax_set">
                    <input
                      type="text"
                      className="form-control card_form_height"
                      placeholder="Registered VAT/GST/Tax ID"
                    />
                    <button className="taxsave_btn">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-5 col-lg-5 col-sm-8">
            <div className="purchase_summary">
              <h3>Purchase summary</h3>
              <ul className="plan_currency">
                <li>
                  <h6>
                    Billed in{" "}
                    <span style={{ color: "#2A1FB3" }}>Indian Rupee</span>{" "}
                  </h6>
                </li>
              </ul>

              <ul className="silverplan_list">
                <li>
                  <h4>Total Variations Created</h4>
                  <h5 className="copupon">
                    {`${localStorage.getItem("variationcounts")} ${
                      localStorage.getItem("variationcounts") > 1
                        ? "Images"
                        : "Image"
                    }`}{" "}
                    X 10 Per Variation
                  </h5>
                </li>
                <li>
                  <h4 className="plan_cost">
                    ₹ {localStorage.getItem("variationcounts") * 10}
                  </h4>
                </li>
              </ul>
              <ul className="silverplan_list">
                <li>
                  <h4>Tax</h4>
                  <h5 className="copupon">18% GST Applied on</h5>
                  <h5 className="copupon_code">27CQOPP0264R1ZY</h5>
                </li>
                <li>
                  <h4 className="plan_cost">
                    ₹{" "}
                    {(
                      0.18 *
                      (localStorage.getItem("variationcounts") * 10)
                    ).toFixed(2)}
                  </h4>
                </li>
              </ul>
              {selectedPlan?.id != 2 && (
                <ul className="silverplan_list silverplan_list_total">
                  <li>
                    <h4>Total</h4>
                  </li>
                  <li>
                    <h4 className="total_cost">
                      ₹{" "}
                      {+localStorage.getItem("variationcounts") * 10 +
                        +(
                          0.18 *
                          (localStorage.getItem("variationcounts") * 10)
                        ).toFixed(2)}
                    </h4>
                  </li>
                </ul>
              )}

              <button
                className="pay_btn"
                onClick={(e) => {
                  submitHandler();
                }}
              >
                <img src={"/assets/images/lockwhite.svg"} alt="" />
                Pay Now
              </button>

              <p>
                By selecting “Pay now”, I authorize Variant Technology to charge
                my payment.
              </p>

              <ul className="email_receipt">
                {userDetails["email"] && isValidEmail(userDetails["email"]) && (
                  <li>
                    <p>Your receipt will be sent to</p>
                    <h6>{userDetails["email"]}</h6>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="cooupon_modal_div">
        <Modal
          zIndex={2000}
          centered
          scrollable
          className="event_modal cupon_modal"
          isOpen={modal2}
          toggle={toggle2}
        >
          <ModalHeader toggle={toggle2}>&nbsp;</ModalHeader>
          <div className="modal_back"></div>
        </Modal>
      </div>
    </>
  );
}
